/* Explee-style data stream for the synthetic research block: dotted curves
   from both edges carry data points into the central "tube" pill. Canvas
   only runs while on screen; reduced motion gets the static curves. */
(function () {
  var canvas = document.getElementById('synthetic-stream-canvas');
  if (!canvas) return;

  var ctx = canvas.getContext('2d');
  var wrap = canvas.parentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var GREEN = '35, 179, 112';
  var GREY = '148, 163, 184';
  var paths = [];
  var dots = [];
  var W, H, dpr;

  function build() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = canvas.clientWidth;
    H = canvas.clientHeight;
    canvas.width = W * dpr;
    canvas.height = H * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    var tube = wrap.querySelector('.tube');
    var tw = tube ? tube.offsetWidth : 260;
    var cy = H / 2;
    paths = [];
    /* Narrow screens get two near-straight lanes per side; wide screens
       fan five curves in from the edges. */
    var narrow = W < 700;
    var perSide = narrow ? 2 : 5;
    [-1, 1].forEach(function (side) {
      for (var i = 0; i < perSide; i++) {
        var sx = side === -1 ? -10 : W + 10;
        var sy = narrow ? cy + (i === 0 ? -14 : 14) : (H * (i + 0.5)) / perSide;
        /* Narrow screens: the lane runs all the way to the pill's centre
           (the canvas sits behind the pill, which hides the last stretch).
           Wide screens: stop at the pill's edge. */
        var ex = W / 2 + (narrow ? 0 : side * (tw / 2 + 14));
        var cx = W / 2 + side * (narrow ? W / 3 : W / 4);
        paths.push({
          sx: sx,
          sy: sy,
          cx: cx,
          cy: narrow ? sy : sy < cy ? sy * 0.4 : H - (H - sy) * 0.4,
          ex: ex,
          ey: cy,
          narrow: narrow
        });
      }
    });
    dots = [];
    for (var d = 0; d < paths.length * 2; d++) {
      dots.push({
        p: d % paths.length,
        t: Math.random(),
        v: 0.0025 + Math.random() * 0.0045
      });
    }
  }

  function pointAt(p, t) {
    var u = 1 - t;
    return {
      x: u * u * p.sx + 2 * u * t * p.cx + t * t * p.ex,
      y: u * u * p.sy + 2 * u * t * p.cy + t * t * p.ey
    };
  }

  function drawPaths() {
    ctx.clearRect(0, 0, W, H);
    ctx.setLineDash([1.5, 7]);
    ctx.lineWidth = 1.5;
    paths.forEach(function (p) {
      ctx.strokeStyle = 'rgba(' + GREY + ', 0.35)';
      ctx.beginPath();
      ctx.moveTo(p.sx, p.sy);
      ctx.quadraticCurveTo(p.cx, p.cy, p.ex, p.ey);
      ctx.stroke();
    });
    ctx.setLineDash([]);
  }

  function frame() {
    drawPaths();
    dots.forEach(function (d) {
      d.t += d.v;
      if (d.t >= 1 || d.p >= paths.length) {
        d.t = 0;
        d.p = Math.floor(Math.random() * paths.length);
      }
      var p = paths[d.p];
      var pos = pointAt(p, d.t);
      var fade = d.t < 0.1 ? d.t / 0.1 : 1;
      if (p.narrow) {
        /* Fade out only in the last stretch inside the pill, at its centre. */
        if (d.t > 0.94) fade = (1 - d.t) / 0.06;
      } else if (d.t > 0.85) {
        fade = (1 - d.t) / 0.15;
      }
      ctx.beginPath();
      ctx.arc(pos.x, pos.y, 2.4, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(' + GREEN + ', ' + 0.85 * fade + ')';
      ctx.fill();
    });
    raf = running ? requestAnimationFrame(frame) : null;
  }

  var running = false;
  var raf = null;

  function start() {
    if (running || reduced) return;
    running = true;
    raf = requestAnimationFrame(frame);
  }
  function stop() {
    running = false;
    if (raf) cancelAnimationFrame(raf);
  }

  build();
  drawPaths();

  window.addEventListener('resize', function () {
    build();
    if (!running) drawPaths();
  });

  if (!reduced && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          e.isIntersecting ? start() : stop();
        });
      },
      { threshold: 0.1 }
    ).observe(wrap);
  }
})();
